var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5369 7.37907H13.9999V7.3514H7.99992V10.0181H11.7676C11.2179 11.5704 9.74092 12.6847 7.99992 12.6847C5.79092 12.6847 3.99992 10.8937 3.99992 8.68473C3.99992 6.47573 5.79092 4.68473 7.99992 4.68473C9.01959 4.68473 9.94725 5.0694 10.6536 5.69773L12.5393 3.81207C11.3486 2.7024 9.75592 2.01807 7.99992 2.01807C4.31825 2.01807 1.33325 5.00307 1.33325 8.68473C1.33325 12.3664 4.31825 15.3514 7.99992 15.3514C11.6816 15.3514 14.6666 12.3664 14.6666 8.68473C14.6666 8.23773 14.6206 7.8014 14.5369 7.37907Z",
    fill: "#FFC107"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.10205 5.58173L4.29238 7.18807C4.88505 5.72073 6.32038 4.68473 8.00005 4.68473C9.01972 4.68473 9.94738 5.0694 10.6537 5.69773L12.5394 3.81207C11.3487 2.7024 9.75605 2.01807 8.00005 2.01807C5.43938 2.01807 3.21872 3.46373 2.10205 5.58173Z",
    fill: "#FF3D00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99994 15.3515C9.72194 15.3515 11.2866 14.6925 12.4696 13.6208L10.4063 11.8748C9.71446 12.4009 8.86909 12.6855 7.99994 12.6848C6.26594 12.6848 4.79361 11.5791 4.23894 10.0361L2.06494 11.7111C3.16827 13.8701 5.40894 15.3515 7.99994 15.3515Z",
    fill: "#4CAF50"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.537 7.37874H14V7.35107H8V10.0177H11.7677C11.5047 10.7565 11.0311 11.4021 10.4053 11.8747L10.4063 11.8741L12.4697 13.6201C12.3237 13.7527 14.6667 12.0177 14.6667 8.68441C14.6667 8.23741 14.6207 7.80107 14.537 7.37874Z",
    fill: "#1976D2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogo);
export default __webpack_public_path__ + "static/media/google_logo.0ecb68437a4b8ca02b17655211b4654b.svg";
export { ForwardRef as ReactComponent };